"use strict"
$(document).on('click', '.setup-steps-track', function () {
    localStorage.setItem('stepTrack', $(this).data('step-number'));
});
jQuery(function ($) {
    $('.nav-item').each(function (index) {
        if (window.location.pathname != '/setup/start' && localStorage.getItem('stepTrack') >
            index) {
            $(this).prepend('<i class="fa fa-check-circle"></i>');
        }
    });
});
$(function () {
    $('[data-toggle="tooltip"]').tooltip()
});
jQuery(function ($) {
    $("#databaseDetailsForm").on('submit', function () {
        var total_error = document.querySelectorAll('.form-control:invalid').length;
        console.log(total_error);
        if (total_error === 0) {
            document.getElementById("submitDetails").disabled = 'true';
        }
    });
});